module.exports = __webpack_public_path__ + "img/chamber_definition.cefd9bc4.png";